<script>
  import { locales, getLocale } from "../lib/i18n.svelte.js";
  import { changeLocale } from "../lib/stores/locale.js";

  let open = $state(false);
  let current = $derived(locales.find((l) => l.code === getLocale()) || locales[0]);
</script>

<div class="relative z-[300] isolate">
  <button
    type="button"
    onclick={() => (open = !open)}
    class="relative z-[10] flex items-center gap-1.5 px-2 py-1 text-sm text-zinc-400 hover:text-white rounded hover:bg-white/[0.06] transition-colors"
  >
    <span>{current.flag}</span>
    <span class="hidden sm:inline">{current.code.toUpperCase()}</span>
  </button>

  {#if open}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div
      class="fixed inset-0 z-0 bg-black/20"
      onclick={() => (open = false)}
      role="presentation"
      aria-hidden="true"
    ></div>
    <div
      class="absolute right-0 top-full z-[5] mt-1 min-w-[140px] rounded border border-white/10 bg-zinc-950 p-1 shadow-[0_24px_64px_-12px_rgba(0,0,0,0.95)]"
    >
      {#each locales as locale}
        <button
          type="button"
          onclick={() => {
            changeLocale(locale.code);
            open = false;
          }}
          class="flex items-center gap-2 w-full px-3 py-2 text-sm text-left rounded hover:bg-white/[0.08] transition-colors {locale.code === current.code ? 'text-white' : 'text-zinc-400'}"
        >
          <span>{locale.flag}</span>
          <span>{locale.name}</span>
        </button>
      {/each}
    </div>
  {/if}
</div>
